import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { DatePicker, Button, Input, Layout, Row, Col, Select } from 'antd'
import moment from 'moment'
import { couponStatus } from '@texts/coupons'
@inject((store: any) => {
    const { couponTypesStore, couponsStore } = store
    return { couponTypesStore, couponsStore }
})
@observer
export default class UpdateCoupons extends Component<any, any> {
    handleSubmit = () => {
        const { selected, addCoupons, updateCoupons } = this.props.couponsStore
        selected.length ? updateCoupons() : addCoupons()
    }
    render() {
        const {
            couponsStore: { editValues, setEditValue, selected }
        } = this.props
        return (
            <Layout style={{ backgroundColor: '#f0f2f5', padding: '0.5rem 1rem', marginBottom: '1rem' }}>
                <Row gutter={10}>
                    <Col xs={5}>
                        <label>
                            <strong>כמות קופונים {selected.length ? 'לעריכה' : 'להנפקה'}</strong>
                        </label>
                        <Input
                            disabled={!!selected.length}
                            type="number"
                            placeholder={`כמות קופונים`}
                            min={1}
                            max={10000}
                            onChange={e => setEditValue('amount', e.target.value)}
                            value={selected.length ? selected.length : editValues['amount']}
                        />
                    </Col>
                    <Col xs={5}>
                        <label>
                            <strong>טעינת קופון</strong>
                        </label>
                        <Input
                            type="number"
                            placeholder="הזן טעינה לשימוש"
                            min={1}
                            max={10000}
                            onChange={e => setEditValue('load', e.target.value)}
                            value={editValues['load']}
                        />
                    </Col>
                    <Col xs={5}>
                        <label>
                            <strong>תוקף קופון</strong>
                        </label>
                        <DatePicker
                            style={{ width: '100%', marginBottom: '0' }}
                            placeholder="תאריך תפוגת הקופון"
                            value={'expiration_date' in editValues ? moment(editValues['expiration_date']) : null}
                            onChange={(d, m) => {
                                const date = d ? `${d.format('YYYY-MM-DD')} 23:59:59` : null
                                setEditValue('expiration_date', date)
                            }}
                        />
                    </Col>
                    <Col xs={5}>
                        <label>
                            <strong>מצב הקופון</strong>
                        </label>
                        <Select
                            placeholder="בחר מצב קופון"
                            style={{ width: '100%' }}
                            onChange={e => setEditValue('status', e)}
                        >
                            {Object.keys(couponStatus).map(key => (
                                <Select.Option key={key} value={key}>
                                    {couponStatus[key]}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col xs={4} style={{ paddingTop: '1.8rem' }}>
                        <Button onClick={e => this.handleSubmit()} style={{ width: '100%' }} type="primary">
                            {selected.length ? 'עדכן קופונים' : 'הנפק קופונים'}
                        </Button>
                    </Col>
                </Row>
            </Layout>
        )
    }
}
